import React, { Component } from "react";
import PartnerFormPage from "./PartnerFormPage";
import {
  createServicePartner,
  getServicePartnerNames,
  uploadServicePartnerLogo,
} from "api/service partner/PartnerApi";
import { getApiErrorMessage } from "utils/getApiErrorMessage";
import {
  EMPTY_PARTNER,
  openGoogleMaps,
  togglePartnerFeatureSubtype,
  togglePartnerFeatureType,
  updatePartnerField,
  validatePartner,
} from "./partnerFormUtils";
import "./partners.css";

class CreatePartner extends Component {
  state = {
    partner: { ...EMPTY_PARTNER },
    errors: {},
    message: "",
    submitting: false,
    messageType: "info",
    logoFile: null,
    partnerNames: [],
    partnerNamesLoading: true,
  };

  componentDidMount() {
    const token = JSON.parse(localStorage.getItem("user"));

    getServicePartnerNames(token.token)
      .then((res) =>
        this.setState({
          partnerNames: Array.isArray(res.data) ? res.data : [],
          partnerNamesLoading: false,
        }),
      )
      .catch(() => this.setState({ partnerNamesLoading: false }));
  }

  onLogoChange = (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) {
      this.setState((state) => ({ errors: { ...state.errors, logo: "Logo must be 2 MB or smaller." } }));
      return;
    }
    this.setState((state) => ({
      logoFile: file,
      partner: { ...state.partner, logo: URL.createObjectURL(file) },
      errors: { ...state.errors, logo: null },
    }));
  };

  onChange = (event) => {
    const { name, type, checked, value } = event.target;
    const fieldValue = type === "checkbox" ? checked : value;
    this.setState((state) => ({
      partner: updatePartnerField(state.partner, name, fieldValue),
      errors: { ...state.errors, [name]: null },
      message: "",
    }));
  };

  onFeatureTypeChange = (type, enabled) => {
    this.setState((state) => ({
      partner: togglePartnerFeatureType(state.partner, type, enabled),
      errors: { ...state.errors, partnerFeatures: null },
      message: "",
    }));
  };

  onFeatureSubtypeChange = (type, subtype, enabled) => {
    this.setState((state) => ({
      partner: togglePartnerFeatureSubtype(
        state.partner,
        type,
        subtype,
        enabled,
      ),
      errors: { ...state.errors, partnerFeatures: null },
      message: "",
    }));
  };

  validate = () => {
    const errors = validatePartner(this.state.partner);
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  onSubmit = (event) => {
    event.preventDefault();
    if (!this.validate()) return;

    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    this.setState({ submitting: true, message: "" });
    const logoUpload = this.state.logoFile
      ? uploadServicePartnerLogo(this.state.logoFile, obj)
      : Promise.resolve(null);

    logoUpload
      .then((upload) => createServicePartner({
        ...this.state.partner,
        logo: upload && upload.data ? upload.data.logo : this.state.partner.logo,
      }, obj))
      .then((res) => {
        this.setState({
          partner: { ...EMPTY_PARTNER },
          submitting: false,
          messageType: "success",
          message: res.message || "Partner created successfully.",
        });
        const returnTo = this.props.location.state && this.props.location.state.returnTo;
        this.props.history.push(returnTo || "/admin/Service-partners-Branch", {
          createdPartnerId: res.data && res.data.id,
        });
      })
      .catch((error) =>
        this.setState({
          submitting: false,
          messageType: "danger",
          message: getApiErrorMessage(error),
        }),
      );
  };

  render() {
    return (
      <PartnerFormPage
        submitLabel="Create Service Partner"
        submittingLabel="Creating Partner..."
        onSubmit={this.onSubmit}
        onBack={() => this.props.history.push(
          (this.props.location.state && this.props.location.state.returnTo) ||
            "/admin/Service-partners-Branch",
        )}
        message={this.state.message}
        messageType={this.state.messageType}
        submitting={this.state.submitting}
        value={this.state.partner}
        inactiveLabel="Create as inactive"
        errors={this.state.errors}
        onChange={this.onChange}
        onGetLocation={openGoogleMaps}
        onLogoChange={this.onLogoChange}
        onFeatureTypeChange={this.onFeatureTypeChange}
        onFeatureSubtypeChange={this.onFeatureSubtypeChange}
        partnerNames={this.state.partnerNames}
        partnerNamesLoading={this.state.partnerNamesLoading}
      />
    );
  }
}

export default CreatePartner;
